export var FacebookChannelType;
(function (FacebookChannelType) {
    FacebookChannelType[FacebookChannelType["MESSAGE"] = 10] = "MESSAGE";
    FacebookChannelType[FacebookChannelType["POST"] = 20] = "POST";
})(FacebookChannelType || (FacebookChannelType = {}));
//# sourceMappingURL=facebook-channel-type.enum.js.map